<template>
    <div class="w-full h-14 bg-red-600 flex items-center">
        <div class="px-4 flex items-center gap-2 text-white">
            <div class="p-2 rounded-lg2 bg-red-700">
                <Icon
                    :name="iconName"
                    class="w-6 h-6"
                />
            </div>
            <div class="font-bold tracking-wide">
                {{ title }}
            </div>
            <div>
                {{ message }}
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import Icon from '@/Shared/Component/Icon.vue'

    const props = defineProps({
        iconName: {
            type: String,
            default: null,
        },
        title: {
            type: String,
            default: null,
        },
        message: {
            type: String,
            default: null,
        },
        color: {
            type: String,
            default: null,
        },
    })
</script>
